import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Container, Typography, Box, CircularProgress, Alert, Button } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import API from "../../utils/Axios.utils";

const CandidateInterviewSuccess = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const bookingRef = searchParams.get("booking_ref");
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [interviewData, setInterviewData] = useState(null);
  
  const hasConfirmed = useRef(false);

  useEffect(() => {
    if (!token || !bookingRef) {
      setError("Missing booking information. Your link may be broken.");
      setLoading(false);
      return;
    }

    if (hasConfirmed.current) return;
    hasConfirmed.current = true;

    const confirmBooking = async () => {
      try {
        const response = await API.post(`api/interview/public/${token}/confirm-booking`, { booking_ref: bookingRef });
        if (response?.data?.status === 'success') {
          setInterviewData(response.data.data);
        }
      } catch (err) {
        setError(err.response?.data?.message || "Could not confirm booking. It may have already been confirmed, or there was a network error.");
      } finally {
        setLoading(false);
      }
    };

    confirmBooking();
  }, [token, bookingRef]);

  if (loading) {
    return (
      <Box sx={{ minHeight: "100vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ minHeight: "100vh", display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: "#f8fafc" }}>
        <Container maxWidth="sm">
          <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: "#f8fafc" }}>
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <CheckCircleIcon sx={{ fontSize: 80, color: "#0f9d78", mb: 2 }} />
        <Typography variant="h4" fontWeight={700} color="textPrimary" gutterBottom>
          Interview Confirmed!
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
          Thank you, {interviewData?.candidate_name}. Your {interviewData?.stage?.replace('_', ' ')} has been successfully scheduled.
          <br /><br />
          You will receive a calendar invitation shortly with the Google Meet link.
        </Typography>
        <Button variant="contained" href="https://talentengine.com" sx={{ bgcolor: "#0f9d78", borderRadius: 8, px: 4, textTransform: "none" }}>
          Return to Website
        </Button>
      </Container>
    </Box>
  );
};

export default CandidateInterviewSuccess;
